import {Translate} from "../../../../../locales/locales-utils";

export const copyRightProps = () => {
  return {
    copyRight: {
      text: " WaveAccess",
      href: "https://www.waveaccess.ru/",
    },
    privacy: {
      shortText: Translate("Global.Footer.TermsAndConditions"),
      text: Translate("Global.Footer.TermsAndConditions"),
      href: "/privacypolicy/",
    },
    consent: {
      shortText: Translate('Global.Footer.PersonalDataConsent'),
      text: Translate('Global.Footer.PersonalDataConsent'),
      href: '/consent-processing/',
    },
    userAgreement: {
      shortText: Translate('Global.Footer.UserAgreement'),
      text: Translate('Global.Footer.UserAgreement'),
      href: '/user-agreement/',
    },
    classes: ["copy-right-ru"],
  }

};
